import { Box, Text } from '@chakra-ui/react';

const NotFound = () => {
  return (
    <Box textAlign="center" mt={20}>
      <Text fontSize="3xl" fontWeight="bold">404</Text>
      <Text fontSize="xl">Pagina non trovata!</Text>
    </Box>
  );
};

export default NotFound;